import '../CsvJsonInfoPages.scss';


function PublishedSequence() {

  const data = [
    ['1', 'Description'],
    ['2', 'Sequence Number'],
    ['3', 'Publish Date yyyy/mm/dd'],
    ['4', '0 = Incremental file 1 = Full Monthly Refresh'],
  ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>Used Values Live - Published Sequence</h1>
            <p> A single record providing the daily sequence used to publish values<br/><br/>
                <b>File Naming Convention</b></p>
            <p>The &lt;FILENAME&gt; is dependant on the product being produced as follows.<br/>

                CAR_yyyy-mm-dd_UsedValuesLive_Sequence.txt<br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.<br />
            </p>

          <table>
      <thead>
        <tr>
          <th>Field</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td>{row[0]}</td>
            <td>{row[1]}</td>
          </tr>
        ))}
      </tbody>
    </table>
        </div>
    );
}

export default PublishedSequence;
